var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsupIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.625 8.1249a1.87 1.87 0 0 1 .5513.0831 1.875 1.875 0 0 1 1.2418 2.3432l-1.7306 5.625a1.866 1.866 0 0 1-1.7937 1.3237H6.25V9.6487l2.5-3V3.7499a.625.625 0 0 1 .1925-.4519.636.636 0 0 1 .4587-.1731c.8557.0363 2.4738.735 2.4738 3.125v1.875zm-12.5.625h1.25A.625.625 0 0 1 5 9.375V17.5H3.125a.625.625 0 0 1-.625-.625v-7.5a.625.625 0 0 1 .625-.625",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsupIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thumbsup-icon.153be4d7d4200d6a4ad6c68ab9cf1863.svg";